module.exports = __webpack_public_path__ + "static/img/ex08.dc8bf850.png";